import { Controller } from "@hotwired/stimulus"

// セット商品の出庫数量をリアルタイム計算するコントローラー
export default class extends Controller {
  static targets = ["sets", "sell", "samples", "quantity"]
  static values = {
    sellQuantityPerSet: Number,
    sampleQuantityPerSet: Number
  }

  connect() {
    this.calculate()
  }

  calculate() {
    const sets = this.hasSetsTarget ? (parseInt(this.setsTarget.value) || 0) : 0

    const sell = sets * this.sellQuantityPerSetValue
    const samples = sets * this.sampleQuantityPerSetValue
    const quantity = sell + samples

    if (this.hasSellTarget) {
      this.sellTarget.textContent = sell || ''
    }
    if (this.hasSamplesTarget) {
      this.samplesTarget.textContent = samples || ''
    }
    if (this.hasQuantityTarget) {
      this.quantityTarget.textContent = quantity
    }
  }
}
